import { Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { useScreenSize } from "design-system/hooks";

import s from "./VerifyEmailScreen.module.css";

interface Props {
  email: string;
}

export const VerifyEmailScreen = ({ email }: Props) => {
  const { t } = useTranslation("sandbox");
  const size = useScreenSize();
  const showHero = !["xs", "sm"].includes(size);

  return (
    <Flex vertical align="center" justify="center" className={s.page}>
      <Flex className={s.card}>
        <Flex vertical justify="center" className={s.content}>
          <Typography.Title level={2} className={s.heading}>
            {t("components.verifyEmailScreen.title")}
          </Typography.Title>
          <Typography.Paragraph className={s.description}>
            {t("components.verifyEmailScreen.description", { email })}
          </Typography.Paragraph>
          <Typography.Paragraph className={s.instruction}>
            {t("components.verifyEmailScreen.instruction")}
          </Typography.Paragraph>
        </Flex>

        {showHero && (
          <Flex align="center" justify="center" className={s.heroPanel}>
            <img
              src="/images/cardCreatedSuccessfully.png"
              alt=""
              className={s.heroImage}
            />
          </Flex>
        )}
      </Flex>
      <p className={s.fineprint}>{t("auth.fineprint")}</p>
    </Flex>
  );
};
